import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../layout/theme-next';
import { NextTheme } from '../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>(theme => ({
  enabledIcon: {
    fontSize: 20,
    color: Colors.success,
    marginRight: theme.spacing(0.5),
    verticalAlign: 'middle',
  },
  enabledLabel: {
    marginRight: theme.spacing(1),
    verticalAlign: 'middle',
  },
}));
